var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2807_16824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5527 0H1.44733C0.648 0 0 0.648 0 1.44733V14.5526C0 15.352 0.648 16 1.44733 16H14.5526C15.352 16 16 15.352 16 14.5526V1.44733C16 0.648 15.352 0 14.5527 0ZM4.95108 13.8155C4.95108 14.0481 4.76251 14.2366 4.52988 14.2366H2.73696C2.50434 14.2366 2.31577 14.0481 2.31577 13.8155V6.2996C2.31577 6.06697 2.50434 5.87841 2.73696 5.87841H4.52988C4.76251 5.87841 4.95108 6.06697 4.95108 6.2996V13.8155ZM3.63342 5.16993C2.69273 5.16993 1.93014 4.40733 1.93014 3.46664C1.93014 2.52595 2.69273 1.76335 3.63342 1.76335C4.57412 1.76335 5.33671 2.52595 5.33671 3.46664C5.33671 4.40733 4.57416 5.16993 3.63342 5.16993ZM14.3208 13.8494C14.3208 14.0632 14.1474 14.2366 13.9336 14.2366H12.0096C11.7958 14.2366 11.6224 14.0632 11.6224 13.8494V10.324C11.6224 9.79811 11.7766 8.01948 10.248 8.01948C9.06228 8.01948 8.82178 9.2369 8.77349 9.78325V13.8494C8.77349 14.0632 8.60013 14.2366 8.38622 14.2366H6.52544C6.31158 14.2366 6.13818 14.0632 6.13818 13.8494V6.26568C6.13818 6.05181 6.31158 5.87841 6.52544 5.87841H8.38622C8.60008 5.87841 8.77349 6.05181 8.77349 6.26568V6.92138C9.21315 6.26157 9.86655 5.75229 11.2578 5.75229C14.3385 5.75229 14.3208 8.63045 14.3208 10.2119V13.8494Z",
    fill: "#CFCFCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2807_16824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.783ded765b942248b7aeb0ef2952d404.svg";
export { ForwardRef as ReactComponent };